import { useSyncExternalStore } from "react";

import { getSupportUnread, subscribeSupportUnread } from "../helpers/helpers";

/** Unread replies waiting in the support Messenger. */
export const useSupportUnread = (): number =>
  useSyncExternalStore(subscribeSupportUnread, getSupportUnread, () => 0);
